import React from "react";

export default function ActionIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 36 36" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <path d="m30.66 13.21a1.07 1.07 0 0 0 -.93-.54h-10.66v-9.6a1.07 1.07 0 0 0 -2-.56l-11.71 19.2a1.07 1.07 0 0 0 .91 1.62h10.66v9.6a1.07 1.07 0 0 0 .78 1 1.09 1.09 0 0 0 1.2-.47l11.73-19.2a1.07 1.07 0 0 0 .02-1.05zm-11.59 15.93v-6.87a1.07 1.07 0 0 0 -1.07-1.07h-9.83l8.76-14.34v6.88a1.07 1.07 0 0 0 1.07 1.06h9.83z" fill={filteredStyles.fill}/>
    </svg>
  );
}
